import { useTranslation } from "react-i18next";
import KiloNewton from "../../../../../../components/Math/Units/Metric/KiloNewton";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function BemessungswertDesBiegeknickwiderstand({ biegeknickbeanspruchbarkeit }) {
  const { t } = useTranslation("translation");

  const BemessungswertDesBiegeknickwiderstandFormula = `\\displaystyle {N_{\\tiny _{b,Rd}}} = \\frac{\\chi \\cdot A_s \\cdot f_{yk}}{\\gamma_{\\tiny _{M1}}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.dinEN1993.verification.designValueFlexuralBuckling")}</p>}
      indicesValue={
        <span>
          N<sub>b,Rd</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={biegeknickbeanspruchbarkeit} decimalScale={2} />
        </span>
      }
      formulaValue={
        <ToolTip
          id={"BemessungswertDesBiegeknickwiderstandFormula"}
          type={IconType.FORMULA}
          formula={BemessungswertDesBiegeknickwiderstandFormula}
        />
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default BemessungswertDesBiegeknickwiderstand;
